"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Notification = _interopRequireDefault(require("../../Atoms/Notification"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _common = require("../../../core/utils/common");
var SKURestrictedTiles = function SKURestrictedTiles(_ref) {
  var purchasable = _ref.purchasable,
    isObsoleteDiscontinued = _ref.isObsoleteDiscontinued,
    isObsoleteDiscontinuedWithReplacement = _ref.isObsoleteDiscontinuedWithReplacement,
    labels = _ref.labels,
    config = _ref.config,
    productReferences = _ref.productReferences,
    isSKUUnbuyable = _ref.isSKUUnbuyable,
    isUnavailableItem = _ref.isUnavailableItem,
    addToCartDisabled = _ref.addToCartDisabled;
  var unavailableMaterialDescription = labels.unavailableMaterialDescription,
    obsoleteDiscontinuedDescription = labels.obsoleteDiscontinuedDescription,
    obsoleteDiscontinuedReplacementDescription = labels.obsoleteDiscontinuedReplacementDescription,
    skuBuyableDescription = labels.skuBuyableDescription,
    skuErrorCodeDescription = labels.skuErrorCodeDescription,
    contactWaters = labels.contactWaters;
  var unavailableIconUrl = config.unavailableIconUrl,
    contactUsLink = config.contactUsLink;
  var productReferenceTarget = (0, _lodash.get)(productReferences, ['0', 'target'], {});
  var _productReferenceTarg = productReferenceTarget.code,
    code = _productReferenceTarg === void 0 ? '' : _productReferenceTarg;
  var contactWatersLink = _react.default.createElement(_Anchor.default, {
    to: contactUsLink,
    elementLocator: "notification-container-attention-unavailable-link-text"
  }, contactWaters);
  var getNotification = function getNotification() {
    if (isObsoleteDiscontinuedWithReplacement) {
      return _react.default.createElement(_Notification.default, {
        description: (0, _common.getLabelWithParam)(obsoleteDiscontinuedReplacementDescription, [code]),
        icon: unavailableIconUrl,
        variation: "attention",
        elementLocator: "notification-container-attention-unavailable"
      });
    }
    if (isObsoleteDiscontinued) {
      return _react.default.createElement(_Notification.default, {
        description: obsoleteDiscontinuedDescription,
        icon: unavailableIconUrl,
        variation: "attention",
        elementLocator: "notification-container-attention-unavailable"
      });
    }
    if (!purchasable || addToCartDisabled) {
      return _react.default.createElement(_Notification.default, {
        description: unavailableMaterialDescription,
        icon: unavailableIconUrl,
        variation: "attention",
        elementLocator: "notification-container-attention-unavailable"
      });
    }
    if (isSKUUnbuyable) {
      return _react.default.createElement(_Notification.default, {
        description: (0, _common.getLabelWithParam)(skuBuyableDescription, [code]),
        icon: unavailableIconUrl,
        variation: "attention",
        elementLocator: "notification-container-attention-unavailable"
      });
    }
    if (isUnavailableItem) {
      return _react.default.createElement(_Notification.default, {
        description: (0, _common.getLabelWithComponent)(skuErrorCodeDescription, [contactWatersLink]),
        icon: unavailableIconUrl,
        variation: "attention",
        elementLocator: "notification-container-attention-unavailable"
      });
    }
  };
  return getNotification();
};
SKURestrictedTiles.defaultProps = {
  purchasable: false,
  isObsoleteDiscontinued: false,
  isObsoleteDiscontinuedWithReplacement: false,
  labels: {},
  config: {},
  productReferences: [],
  isSKUUnbuyable: false,
  isUnavailableItem: false,
  addToCartDisabled: false
};
var _default = SKURestrictedTiles;
exports.default = _default;
module.exports = exports["default"];